export default __webpack_public_path__ + "static/media/5.712c5a7e.png";